import React from 'react';
import {
    Email,
    Phone,
    LocationOn,
    AccessTime,
    HeadsetMic,
    CalendarMonth,
    Language,
    Support
} from '@mui/icons-material';

const ContactPage = () => {
    const contactMethods = [
        {
            icon: <Email style={{ fontSize: 48, color: '#2563eb' }} />,
            title: "Email Support",
            primary: "wakinniranye@yahoo.com",
            secondary: "General inquiries & support",
            description: "Get in touch via email for any questions or support needs",
            action: () => window.location.href = 'mailto:wakinniranye@yahoo.com',
            buttonText: "Send Email"
        },
        {
            icon: <Phone style={{ fontSize: 48, color: '#16a34a' }} />,
            title: "Phone Support",
            primary: "+1 (555) 123-4567",
            secondary: "Monday - Friday, 9AM - 6PM EST",
            description: "Speak directly with our support team",
            action: () => window.location.href = 'tel:+447448850674',
            buttonText: "Call Now"
        },

    ];

    return (
        <div style={{ minHeight: '100vh', background: '#f9fafb' }}>
            {/* Header Spacer */}
            <div style={{ height: '64px' }}></div>

            {/* Hero Section */}
            <section style={{ padding: '80px 0', background: 'linear-gradient(135deg, #eff6ff 0%, #ffffff 50%, #eff6ff 100%)' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px', textAlign: 'center' }}>
                    <h1 style={{
                        fontSize: '48px',
                        fontWeight: 'bold',
                        marginBottom: '24px',
                        color: '#111827'
                    }}>
                        Contact RiskAS
                    </h1>
                    <p style={{
                        fontSize: '24px',
                        color: '#6b7280',
                        maxWidth: '800px',
                        margin: '0 auto 40px auto',
                        lineHeight: '1.6'
                    }}>
                        Get in touch with our team. We're here to help you with any questions
                        about RiskAS and how it can transform your risk management.
                    </p>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '32px',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#2563eb', marginBottom: '8px' }}>
                                2hrs
                            </div>
                            <div style={{ color: '#6b7280', fontSize: '14px' }}>Response Time</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#16a34a', marginBottom: '8px' }}>
                                24/7
                            </div>
                            <div style={{ color: '#6b7280', fontSize: '14px' }}>Support</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#7c3aed', marginBottom: '8px' }}>
                                750+
                            </div>
                            <div style={{ color: '#6b7280', fontSize: '14px' }}>Happy Clients</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#dc2626', marginBottom: '8px' }}>
                                3
                            </div>
                            <div style={{ color: '#6b7280', fontSize: '14px' }}>Global Offices</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Methods */}
            <section style={{ padding: '80px 0', background: 'white' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px' }}>
                    <h2 style={{ fontSize: '36px', fontWeight: 'bold', color: '#111827', marginBottom: '16px', textAlign: 'center' }}>
                        How Can We Help You?
                    </h2>
                    <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '48px', textAlign: 'center' }}>
                        Choose the best way to reach us based on your needs
                    </p>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '32px' }}>
                        {contactMethods.map((method, index) => (
                            <div key={index} style={{
                                background: 'white',
                                border: '1px solid #e5e7eb',
                                borderRadius: '16px',
                                padding: '40px',
                                textAlign: 'center',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 20px 25px rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
                                }}
                            >
                                <div style={{ marginBottom: '24px' }}>
                                    {method.icon}
                                </div>
                                <h3 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '12px' }}>
                                    {method.title}
                                </h3>
                                <div style={{ fontSize: '20px', fontWeight: '600', color: '#2563eb', marginBottom: '8px' }}>
                                    {method.primary}
                                </div>
                                <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
                                    {method.secondary}
                                </div>
                                <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px', lineHeight: '1.5' }}>
                                    {method.description}
                                </p>
                                <button
                                    onClick={method.action}
                                    style={{
                                        background: '#2563eb',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 32px',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        transition: 'background 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = '#1d4ed8'}
                                    onMouseLeave={(e) => e.target.style.background = '#2563eb'}
                                >
                                    {method.buttonText}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* Emergency Support */}
            <section style={{ padding: '60px 0', background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)', color: 'white' }}>
                <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 16px', textAlign: 'center' }}>
                    <h2 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '16px' }}>
                        Need Urgent Support?
                    </h2>
                    <p style={{ fontSize: '16px', marginBottom: '24px', opacity: 0.9 }}>
                        For critical issues that require immediate attention, contact our emergency support line.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
                        <button
                            onClick={() => window.location.href = 'tel:+15559990000'}
                            style={{
                                background: 'white',
                                color: '#dc2626',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <Phone style={{ fontSize: 20 }} />
                            Emergency: +1 (555) 999-0000
                        </button>
                        <button
                            onClick={() => window.location.href = 'mailto:wakinniranye@yahoo.com'}
                            style={{
                                background: 'transparent',
                                color: 'white',
                                border: '2px solid white',
                                padding: '10px 24px',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <Email style={{ fontSize: 20 }} />
                            wakinniranye@yahoo.com
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactPage;